<template>
  <div>
    <img v-show="!showList" src="@/assets/image/mobileBack.png" class="header-img" @click="back()" />
    <div class="header">
      <div class="header-font">武夷文化</div>
    </div>
    <div v-show="showList">
      <div class="row">
        <div v-for="item in titleList" :key='item.id'>
          <div :class="[chooseId == item.id ? 'headCardChecked' : 'headCard' ]" @click="handleClick(item.id,item.pid)">
            {{item.name}}
          </div>
        </div>
      </div>
      <div style="background:#EFEFEF;height:0.8vh"></div>
      <div v-for="item in dataSource" :key="item.id" style="margin: 2%">
        <div class="box-card" @click="handleSecondClick(item.id,item.meta.type,item)">{{item.name}}</div>
      </div>
    </div>
    <!-- 详情 -->
    <div class="body" v-show="!showList" style="padding:4vw">
      <div style="height:5.3333vw"></div>
      <div class="body-mobile-top">
        {{ info.title }}
      </div>
      <div style="height:5.3333vw"></div>
      <div class="body-row" style="align-items:center; justify-content:center;">
        <!-- <div class="body-tittle-little">点击</div>
        <div style="width:1.87vw"></div>
        <div class="body-tittle-num">{{info.hits}}</div> -->
        <div style="width:3.0666vw"></div>
        <div class="body-tittle-little">发布日期</div>
        <div style="width:1.87vw"></div>
        <div class="body-tittle-num">{{info.showTime}}</div>

        <div style="width:1.87vw"></div>
        <div class="body-tittle-little">点击量</div>
        <div style="width:1.87vw"></div>
        <div class="body-tittle-num">{{ info.hits }}</div>

      </div>
      <div style="height:5.3333vw"></div>
      <div class="body-line"></div>
      <div style="height:5.3333vw"></div>
      <div v-html="info.details" style="font-size:3.73333vw;font-weight:400;color:#071420" class="infoDetails">
        <!-- {{ info.details }} -->
      </div>
    </div>
    <div class="footer"></div>
  </div>
</template>
<style>
.infoDetails img{
  width: 100%;
}
</style>
<script>
// import { getMenuOpenList } from "@/api/common";
import { getMenuOpenList } from "@/api/publicApi";
import { addHits } from "@/util/publicHits";
export default {
  name: "Notice",
  data() {
    return {
      current: 1,
      pageSize: 10,
      datalist: [],
      total: 0,
      showList: true,
      info: {},
      titleList: [],
      chooseId: 0,
      dataSource: []
    };
  },
  mounted() {
    this.getNoticeFunction()
  },
  methods: {
    //公告头部
    async getNoticeFunction() {
      let pid = 0
      let type = 1
      let current = 1
      let pageSize = 5
      const { code, data } = await getMenuOpenList(pid, type, current, pageSize);
      if (code == 200) {
        this.titleList = data.records;
        if (this.titleList.length > 0) {
          this.chooseId =  this.titleList[0].id
          let type = 1
          let current = 1
          let pageSize = 1000
          const { code, data } = await getMenuOpenList(this.titleList[0].id, type, current, pageSize);
          if (code == 200) {
            this.dataSource = data.records;
          }
        }
      }
    },
    open(item) {
      this.info = item
      this.showList = false
    },
    back() {
      this.info = {}
      this.showList = true
    },
    //标题点击
    async handleClick(id) {
      this.chooseId = id
      let type = 1
      let current = 1
      let pageSize = 1000
      const { code, data } = await getMenuOpenList(id, type, current, pageSize);
      if (code == 200) {
        this.dataSource = data.records;
      }
    },
    //二级点击
    async handleSecondClick(id, type, item) {
      addHits(item.id)
      console.log(id, type, item)
      if (type === "catalogue") {
        // 目录
        let type = 1
        let current = 1
        let pageSize = 1000
        const { code, data } = await getMenuOpenList(id, type, current, pageSize);
        if (code == 200) {
          this.dataSource = data.records;
        }
      } else {
        //详情
        console.log(item)
        this.info = item
        this.showList = false
      }
    }
  }
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 5.7266vh;
  background: #dcdcdc;
  text-align: center;
}
.header-font {
  font-size: 2.216vh;
  line-height: 5.7266vh;
  text-align: center;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #071420;
}
.body-card {
  width: 91.466%;
  height: 17.733vh;
  background: #f6faff;
  border-radius: 4.266vw;
  margin: 4.2666vw 4.2666vw 0 4.2666vw;
}
.footer {
  height: 4.2666vw;
}
.body-row {
  display: flex;
  flex-direction: row;
}
.body-column {
  display: flex;
  flex-direction: column;
}
.body-img {
  width: 32vw;
  height: 11.33vh;
  border-radius: 2.1333vw;
}
.body-card-title {
  font-size: 4.266vw;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #071420;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.body-card-introduce {
  font-size: 3.466vw;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #334251;
  /* height: 4.31vh; */
  display: -webkit-box; /**对象作为伸缩盒子模型展示**/
  -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
  -webkit-line-clamp: 2; /**显示的行数**/
  overflow: hidden; /**隐藏超出的内容**/
}
.body-card-time {
  font-size: 3.2vw;
  font-family: "IcedEarth";
  font-weight: normal;
  color: #8b939a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header-img {
  width: 4.6666vw;
  height: 4.6666vw;
  position: absolute;
  z-index: 1;
  top: 4vw;
  left: 4vw;
}
.body-mobile-top {
  font-size: 4.2666vw;
  font-family: "Source Han Sans CN";
  font-weight: 500;
  color: #071420;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.body-tittle-num {
  font-size: 3.733vw;
  font-family: "IcedEarth";
  font-weight: normal;
  color: #071420;
}
.body-tittle-little {
  font-size: 3.733vw;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #8b939a;
}
.body-line {
  width: 100%;
  height: 0.1333vw;
  text-align: center;
  border-bottom: 1px dashed #8b939a;
}
.box1 {
  width: 300px;
  height: 50px;
  text-align: center;
  padding-top: 30px;
  border-bottom: 2px dashed #000;
}
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 5%;
}
.headCard {
  width: 22vw;
  height: 3vh;
  font-size: 1.866vw;
  text-align: center;
  line-height: 3vh;
  margin: 0px 0px 2.666vw 0px;
  border: 0.133vw solid #dddddd;
  border-radius: 0.666vw;
}
.headCardChecked {
  width: 22vw;
  height: 3vh;
  font-size: 1.866vw;
  text-align: center;
  line-height: 3vh;
  margin: 0px 0px 2.666vw 0px;
  border: 0.133vw solid #dddddd;
  border-radius: 0.666vw;
  color: white;
  background: #4699dd;
}
.box-card {
  width: 100%;
  background: #f6f6f6;
  text-align: left;
  color: #4a75ac;
  padding: 0.8vw 1.3333vw;
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/tea.vue